
import { defineComponent, onMounted } from "vue";
import TrainerList from "@/views/Pending/list/TrainerList.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "dashboard",
  components: {
    TrainerList,
  },
  data() {
    return {
      data: "",
    };
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    });
  },
});
